// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__KrO__"};